/** Human-readable created/updated timestamp for the task details panels,
 *  e.g. "July 7, 2026 at 2:30 PM". Falls back to the raw string on a bad date. */
export function formatCreatedDate(dateString: string): string {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  return date.toLocaleString(undefined, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
